export default "__VITE_ASSET__BEuP5UVA__"